import '../index.css'
import * as React from 'react'
import { Table } from 'antd'
import { ColumnsType } from 'antd/es/table'
import { PageProps } from '../'
import { PaddingBox, PageSubtitle, PageTitle, TabHeader, TableBox } from '../../../components/Wrapper'

interface DataType {
  id: string
  medicationPlan: {
    drugName: string
    dose: string
    type: string
    dosage: number
    perDay: number
  }
  latestRecordDate: string
  logWithinAdherencePercentage: number
}

const columns: ColumnsType<DataType> = [
  { title: 'Medication Name', dataIndex: ['medicationPlan', 'drugName'] },
  { title: 'Adherence', dataIndex: 'logWithinAdherencePercentage' },
  { title: 'Dosage', dataIndex: 'dosage' },
  { title: 'Last Logged', dataIndex: 'latestRecordDate' },
]

/* -------------------------------- react fc -------------------------------- */

const Adherence: React.FC<PageProps> = () => {
  return (
    <>
      <TabHeader border>
        <PageTitle text='Medications' />
      </TabHeader>
      <PaddingBox>
        <PageSubtitle text='Medication Adherence' />
        <TableBox>
          <Table columns={columns} dataSource={[]} rowKey={(record) => record.id} pagination={false} />
        </TableBox>
      </PaddingBox>
    </>
  )
}

export default Adherence
